module.exports = __webpack_public_path__ + "static/media/ios-videocam.b51e8684.svg";